<template>
    <contact-form />
</template>

<script>
    import ContactForm from './components/ContactForm';

    export default {
        components: {
            ContactForm
        },
        created() {
        },
        setup() {
            return {
            }
        }
    }
</script>
